module.exports = ".mat-form-field {\n  padding: 10px; }\n"